import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';
import { PatternFormat } from 'react-number-format';
import * as Layout from '_components/atomic/layouts';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large24X * 10 + 80}px;
  width: 100%;

  @media ${theme.devices.tablet} {
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
  }
`;

const StyledInnerContainer = styled.div`
  padding-left: 10%;
  padding-right: 10%;
  padding-top: ${theme.spaces.large6X}px;
  padding-bottom: ${theme.spaces.large6X}px;

  @media ${theme.devices.tablet} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const TermsSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Layout.Card.Text size={theme.fontSizes.large2X} boldest desktop>
          Terms of Service
        </Layout.Card.Text>
        <Layout.Card.Text size={theme.fontSizes.large} boldest mobile>
          Terms of Service
        </Layout.Card.Text>
        <Layout.Card.Text boldest>1. Acceptance of Terms</Layout.Card.Text>
        <Layout.Card.Text>
          Welcome to Incorpified. By accessing or using our services, you agree
          to comply with and be bound by these Terms of Service. If you do not
          agree to these terms, please do not use our services.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>2. Modifications to Terms</Layout.Card.Text>
        <Layout.Card.Text>
          Incorpified reserves the right to update or change these Terms at any
          time without prior notice. Any modifications will be posted on this
          page, and the &quot;Last Updated&quot; date will be revised. Your
          continued use of the service after any changes constitutes acceptance
          of the new terms.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>3. Description of Service</Layout.Card.Text>
        <Layout.Card.Text>
          Incorpified provides a range of business formation services, including
          but not limited to the formation of LLCs, corporations, and other
          business entities, document preparation and filing, registered agent
          services, and additional business support services. Our services are
          designed to help you comply with the legal requirements for forming
          and maintaining a business entity.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>4. Eligibility</Layout.Card.Text>
        <Layout.Card.Text>
          To use our services, you must be at least 18 years of age. By using
          our services, you represent and warrant that you meet this
          requirement.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>5. User Responsibilities</Layout.Card.Text>
        <Layout.Card.Text boldest>5.1 Accurate Information</Layout.Card.Text>
        <Layout.Card.Text>
          You agree to provide accurate, current, and complete information
          during the registration process and whenever required in the course of
          using our services. Failure to do so may result in the suspension or
          termination of your account and services.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>5.2 Account Security</Layout.Card.Text>
        <Layout.Card.Text>
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activities that occur under your
          account. You agree to notify us immediately of any unauthorized use of
          your account.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>6. Fees and Payments</Layout.Card.Text>
        <Layout.Card.Text boldest>6.1 Service Fees</Layout.Card.Text>
        <Layout.Card.Text>
          Fees for our services are listed on our website and are subject to
          change. All fees are non-refundable unless stated otherwise in our
          Refund Policy.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>6.2 Payment Methods</Layout.Card.Text>
        <Layout.Card.Text>
          We accept various forms of payment, including credit cards and other
          payment methods listed on our website. By providing a payment method,
          you authorize us to charge all fees incurred through your account to
          the designated payment method.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>6.3 Billing Disputes</Layout.Card.Text>
        <Layout.Card.Text>
          If you believe there is an error in billing, you must contact us
          within 30 days of the billing date. We will investigate and attempt to
          resolve any disputes.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>7. Refund Policy</Layout.Card.Text>
        <Layout.Card.Text>
          When you place an order, your order begins processing immediately. Due
          to the varying nature of processing times, you may request
          cancellation after your order has been placed, but we cannot guarantee
          that your order will be canceled. You may be able to cancel your order
          by contacting us via email at&nbsp;
          <a href={`mailto:${config.email}`}>{config.email}</a> or by calling{' '}
          <a href={`tel:${config.phone}`}>
            <PatternFormat
              value={config.phone?.substring(1)}
              displayType="text"
              format="#-(###) ###-####"
              renderText={(value) => value}
            />
          </a>
          .
          <br />
          <br />
          Your order is no longer refundable once we have submitted it to the
          state.
          <br />
          <br />
          Any approved refunds must be requested within six (6) months of the
          original purchase date. Refund requests submitted more than six (6)
          months after the order purchase date will not be eligible for a
          refund.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>8. Intellectual Property</Layout.Card.Text>
        <Layout.Card.Text boldest>8.1 Ownership</Layout.Card.Text>
        <Layout.Card.Text>
          All content on the Incorpified website, including but not limited to
          text, graphics, logos, and software, is the property of Incorpified or
          its licensors and is protected by intellectual property laws.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>8.2 Limited License</Layout.Card.Text>
        <Layout.Card.Text>
          Incorpified grants you a limited, non-exclusive, non-transferable
          license to access and use the website and services for personal or
          internal business use. This license does not include any resale or
          commercial use of the website or its contents.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>9. Privacy Policy</Layout.Card.Text>
        <Layout.Card.Text>
          Our Privacy Policy, which explains how we collect, use, and protect
          your information, is incorporated into these Terms by reference.
          Please review our Privacy Policy for more details.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>10. Third-Party Services</Layout.Card.Text>
        <Layout.Card.Text boldest>
          10.1 Links to Third-Party Websites
        </Layout.Card.Text>
        <Layout.Card.Text>
          Our website may contain links to third-party websites or services that
          are not owned or controlled by Incorpified. We have no control over,
          and assume no responsibility for, the content, privacy policies, or
          practices of any third-party websites or services.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>
          10.2 Third-Party Service Providers
        </Layout.Card.Text>
        <Layout.Card.Text>
          We may use third-party service providers to perform certain services
          on our behalf, including payment processing, data analysis, and
          marketing. These service providers are required to maintain the
          confidentiality of your information and are prohibited from using it
          for any other purpose.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>11. Limitation of Liability</Layout.Card.Text>
        <Layout.Card.Text boldest>
          11.1 Disclaimer of Warranties
        </Layout.Card.Text>
        <Layout.Card.Text>
          Incorpified provides its services &quot;as is&quot; and &quot;as
          available&quot; without any warranties, either express or implied. We
          do not warrant that our services will be uninterrupted, error-free, or
          completely secure.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>
          11.2 Limitation of Liability
        </Layout.Card.Text>
        <Layout.Card.Text>
          To the fullest extent permitted by law, Incorpified will not be liable
          for any indirect, incidental, special, consequential, or punitive
          damages, or any loss of profits or revenues, whether incurred directly
          or indirectly, or any loss of data, use, goodwill, or other intangible
          losses, resulting from (a) your use or inability to use the services;
          (b) any unauthorized access to or use of our servers and/or any
          personal information stored therein; (c) any interruption or cessation
          of transmission to or from our services; (d) any bugs, viruses, trojan
          horses, or the like that may be transmitted to or through our services
          by any third party; or (e) any errors or omissions in any content or
          for any loss or damage incurred as a result of the use of any content
          posted, emailed, transmitted, or otherwise made available through the
          services.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>11.3 Cap on Liability</Layout.Card.Text>
        <Layout.Card.Text>
          In no event shall Incorpified’s total liability to you for all claims
          arising out of or relating to these terms or the use or inability to
          use the services exceed the amount you paid to Incorpified for the
          services.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>12. Indemnification</Layout.Card.Text>
        <Layout.Card.Text>
          You agree to indemnify, defend, and hold harmless Incorpified, its
          affiliates, and their respective officers, directors, employees, and
          agents from and against any and all claims, damages, obligations,
          losses, liabilities, costs, or debt, and expenses (including but not
          limited to attorney’s fees) arising from: (a) your use of and access
          to the services; (b) your violation of any term of these terms; (c)
          your violation of any third-party right, including without limitation
          any copyright, property, or privacy right; or (d) any claim that your
          use of the services caused damage to a third party.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>13. Governing Law</Layout.Card.Text>
        <Layout.Card.Text>
          These Terms are governed by and construed in accordance with the laws
          of the state in which Incorpified operates, without regard to its
          conflict of law principles.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>14. Dispute Resolution</Layout.Card.Text>
        <Layout.Card.Text boldest>14.1 Arbitration</Layout.Card.Text>
        <Layout.Card.Text>
          Any disputes arising out of or relating to these Terms or our services
          will be resolved through binding arbitration in accordance with the
          rules of the American Arbitration Association. The arbitration will
          take place in the state in which Incorpified operates, and the
          arbitrator&apos;s decision will be binding and may be entered as a
          judgment in any court of competent jurisdiction.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>14.2 Class Action Waiver</Layout.Card.Text>
        <Layout.Card.Text>
          You agree that any arbitration or proceeding will be limited to the
          dispute between you and Incorpified individually. You acknowledge and
          agree that you waive the right to participate as a plaintiff or class
          member in any purported class action, collective action, or
          representative proceeding.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>15. Contact Information</Layout.Card.Text>
        <Layout.Card.Text>
          For any questions or concerns about these Terms, please contact us
          at&nbsp;<a href={`mailto:${config.email}`}>{config.email}</a>.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>16. Entire Agreement</Layout.Card.Text>
        <Layout.Card.Text>
          These Terms constitute the entire agreement between you and
          Incorpified regarding the use of our services and supersede all prior
          agreements and understandings.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>17. Severability</Layout.Card.Text>
        <Layout.Card.Text>
          If any provision of these Terms is found to be invalid or
          unenforceable, the remaining provisions will remain in full force and
          effect.
        </Layout.Card.Text>
        <Layout.Card.Text boldest>18. Waiver</Layout.Card.Text>
        <Layout.Card.Text>
          The failure of Incorpified to enforce any right or provision of these
          Terms will not be deemed a waiver of such right or provision.
        </Layout.Card.Text>
        <Layout.Card.Text>
          These Terms were last updated on 05/15/2024
        </Layout.Card.Text>
        <Layout.Card.Text>
          Thank you for choosing Incorpified for your business formation needs.
        </Layout.Card.Text>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default TermsSection;
